import { render, staticRenderFns } from "./MonetaRepayForm.vue?vue&type=template&id=0ed89500&scoped=true&"
import script from "./MonetaRepayForm.vue?vue&type=script&lang=js&"
export * from "./MonetaRepayForm.vue?vue&type=script&lang=js&"
import style0 from "./MonetaRepayForm.vue?vue&type=style&index=0&id=0ed89500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed89500",
  null
  
)

export default component.exports